import React, { createContext, useState } from "react";
import { generateIACarePlan } from "../../utils/services/Careplans/IACareplans/generateIACarePlan";
import { useValidToken } from "../../hooks/useValidToken";

export const IACarePlanContext = createContext();

export const IACarePlanProvider = ({ children }) => {
  const [resultado, setResultado] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { token, isValid, authLoading } = useValidToken();

  const generatePlan = async (patientData) => {
    if (!isValid || authLoading) return;

    setLoading(true);
    setError(null);
    setResultado("");

    try {
      const data = await generateIACarePlan(patientData);
      setResultado(data.resultado);
    } catch (err) {
      setError("Error generando el plan. Intenta nuevamente.");
      console.error("Error en IACarePlanContext:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IACarePlanContext.Provider
      value={{
        resultado,
        loading,
        error,
        generatePlan,
      }}
    >
      {children}
    </IACarePlanContext.Provider>
  );
};
